// src/services/calendarService.js
import { 
    collection, 
    query, 
    getDocs, 
    addDoc, 
    updateDoc, 
    deleteDoc, 
    doc, 
    onSnapshot, 
    serverTimestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase';

const EVENTS_COLLECTION = 'appointments';
const CLIENTS_COLLECTION = 'clients';
const USERS_COLLECTION = 'users';

export const calendarService = {
    /**
     * Suscribe a los eventos del calendario en tiempo real.
     * @param {function} onUpdate - Callback con los datos actualizados.
     * @param {function} onError - Callback de error.
     * @returns {function} Función para desuscribirse.
     */
    subscribeToEvents: (onUpdate, onError) => {
        const q = query(collection(db, EVENTS_COLLECTION));
        return onSnapshot(q, (snapshot) => {
            const events = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            onUpdate(events);
        }, onError);
    },

    /**
     * Obtiene la lista de técnicos (usuarios del sistema).
     */
    getTechnicians: async () => {
        try {
            const q = query(collection(db, USERS_COLLECTION));
            const snapshot = await getDocs(q);
            return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        } catch (error) {
            console.error("Error al obtener técnicos:", error);
            throw error;
        }
    },

    /**
     * Guarda una cita (Crea o Actualiza).
     * @param {Object} eventData - Datos de la cita.
     * @param {string} userEmail - Email del creador (para auditoría).
     * @param {string|null} eventId - ID si es edición, null si es nuevo.
     */
    saveEvent: async (eventData, userEmail, eventId = null) => {
        try {
            if (eventId) {
                // Actualizar
                await updateDoc(doc(db, EVENTS_COLLECTION, eventId), eventData);
            } else {
                // Crear
                await addDoc(collection(db, EVENTS_COLLECTION), {
                    ...eventData,
                    createdAt: serverTimestamp(),
                    createdBy: userEmail
                });
            }
        } catch (error) {
            console.error("Error al guardar evento:", error);
            throw error;
        }
    },

    /**
     * Elimina una cita.
     */
    deleteEvent: async (eventId) => {
        try {
            await deleteDoc(doc(db, EVENTS_COLLECTION, eventId));
        } catch (error) {
            console.error("Error al eliminar evento:", error);
            throw error;
        }
    },

    /**
     * Crea un cliente "Rápido" (Sin RUT) desde la agenda.
     * Usa addDoc para generar un ID automático, ya que no tenemos RUT.
     */
    createQuickClient: async (name) => {
        try {
            const newClientData = {
                nombre: name.trim(),
                rut: 'PENDIENTE', // Flag para que el módulo de Clientes sepa que está incompleto
                email: '',
                telefono: '',
                direccion: '',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            };
            
            const docRef = await addDoc(collection(db, CLIENTS_COLLECTION), newClientData);
            return { id: docRef.id, ...newClientData };
        } catch (error) {
            console.error("Error al crear cliente rápido:", error);
            throw error;
        }
    }
};